import CLIENT from "./client";
import { getApiErrorMessage, getApiErrorStatus } from "./apiError";

export const classifyError = (error) => {
  const status = getApiErrorStatus(error);

  if (status >= 500) return "502";
  if (status === 403) return "403";

  return "network";
};

export const axiosBaseQuery =
  () =>
  async ({ url, method = "GET", params, data }) => {
    try {
      const response = await CLIENT({ url, method, params, data });

      return { data: response.data ?? null };
    } catch (error) {
      return {
        error: {
          status: getApiErrorStatus(error) ?? null,
          kind: classifyError(error),
          message: getApiErrorMessage(error),
        },
      };
    }
  };
